define('type/compilation/Compilation',[
  'jquery',
  'common/module/realtime/Serum.RealtimeUpdater',
  'common/module/realtime/Serum.RelationalRealtimeWidget',
  'type/stream/Serum.RealtimeStream',
  'type/compilation/CompilationStatus',
  'common/js/lib/Serum.Pubsub'
], function($, RealtimeUpdater, RelationalRealtimeWidget, RealtimeStream, CompilationStatus, Pubsub) {
  'use strict';

  var Compilation = function($element) {
    var stream, // eslint-disable-line no-unused-vars
      articleList,
      articlePagingSize,
      status;


    function setupStream() {
      RealtimeUpdater.get().addTarget($element);
      stream = new RealtimeStream($element);
    }

    function pageArticles(e) {
      e.preventDefault();
      var $button = $(this).addClass('is-busy');

      articleList.setRelationLimit(articleList.getRelationLimit() + articlePagingSize);
      articleList.synchronize().done(function() {
        $button.removeClass('is-busy');
      });
    }

    function getRelationClasses() {
      return $('.compilation-articles-container .col.relation').last().attr('class');
    }

    function setupRelatedArticles() {
      var $articles = $('.compilation-articles');
      if (!$articles.length) {
        return;
      }

      RealtimeUpdater.get().addTarget($articles);

      articlePagingSize = parseInt($articles.data('pagingSize'), 10) || 5;

      articleList = new RelationalRealtimeWidget($articles, {
        relationContainer: function() {
          return $articles.find('.compilation-articles-container');
        },
        relationTemplate: function() {
          return '<div class="' + getRelationClasses() + '"></div>';
        },
        relationPerspective: function(relation) {
          return (relation.modelType === 'VideoReference') ? 'RICH' : 'LEAN';
        },
        onAfterInsert : function() {
          Pubsub.publish(Pubsub.topics.CHECK_FOR_NRKNO_EMBED);
        },
        renderInContext: false
      });

      articleList.setDefaultPerspective('LEAN');

      $articles.on('click', '.flow-page-forward', pageArticles);
      $articles.on('realtimerepaint', function(event, data) {
        if (data.master.length < articleList.getRelationLimit()) {
          $element.find('.flow-page-forward').parent().hide();
        } else {
          $element.find('.flow-page-forward').parent().show();
        }
        event.stopImmediatePropagation();
        //event.stopPropagation();
      });
    }

    function scrollToAnchor(e) {
      e.preventDefault();

      var href = $(this).attr('href');
      var $target = $(href);

      $('html, body').animate({
        scrollTop: $target.offset().top - 15
      }, 500);
    }

    function toggleCollapsible() {
      $(this).toggleClass('widget-collapsed');

      Pubsub.publish(Pubsub.topics.TRACK_EVENT, {
        category: 'Compilation',
        action: 'Expand description'
      });
    }

    function setupNavigation() {
      $element.on('click', '.compilation-navigation a', function() {
        Pubsub.publish(Pubsub.topics.TRACK_EVENT, {
          category: 'Compilation',
          action: 'Navigation click',
          label: $(this).text()
        });
      });
      $element.on('click', '.compilation-navigation a', scrollToAnchor);
      $element.one('click', '.widget-collapsible', toggleCollapsible);
    }

    function setupStatus() {
      status = new CompilationStatus($element, false);
      //TODO: er dette den beste eventen å lytte på?
      $element.on('realtimerepaint', function(event, data) { // eslint-disable-line no-unused-vars
        status.update();
      });
    }

    function initialize() {
      setupStream();
      setupRelatedArticles();
      setupNavigation();
      setupStatus();
    }

    initialize();

  };

  Compilation.bootstrap = function() {
    $('.compilation.rich.js-initialize').each(function() {
      new Compilation($(this).removeClass('js-initialize')); // eslint-disable-line no-new
    });
  };

  return Compilation;
});

